import { Immutable } from "immer";
import React from "react";
import { RetailStore } from "tsi-common-react/src/models/location";
import { useStaticURL } from "tsi-common-react/src/utils/urls";
import { jt, t } from "ttag";

import { getWindow } from "@thelabnyc/thelabui/src/utils/dom";

import { LocatorSendResultsModal } from "../LocatorSendResults_Modal";

type IProps = Immutable<{
    stores: Immutable<RetailStore[]>;
    getStoreNumber: (store: Immutable<RetailStore>) => number;
}>;

export const LocatorSendResultsPrint = ({
    stores,
    getStoreNumber,
}: IProps): React.ReactNode => {
    const staticURL = useStaticURL();
    const onSubmit = async () => {
        const window = getWindow();
        if (window) {
            window.print();
        }
    };

    return (
        <LocatorSendResultsModal
            modalClassName="modal-print"
            bodyOpenClassName="locator-print-modal-open"
            buttonLabel={t`Print`}
            buttonImgSrc={`${staticURL}img/locator/icon-print.svg`}
            buttonImgAlt={t`Print`}
            modalTitle={t`Print Your Results`}
            modalDescription={(() => {
                const maxNum = <strong key="max">5</strong>;
                const results = <span key="results">{t`results`}</span>;
                return jt`Check up to ${maxNum} ${results} you would like to print.`;
            })()}
            submitButtonLabel={t`Print`}
            maxSelected={5}
            stores={stores}
            getStoreNumber={getStoreNumber}
            onSubmit={onSubmit}
        />
    );
};
